/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { agentsCreate } from "../funcs/agentsCreate.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ManagedAgent } from "../models/components/managedagent.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  CreateAgentRequest,
  CreateAgentSecurity,
} from "../models/operations/createagent.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type CreateAgentMutationVariables = {
  request: CreateAgentRequest;
  security?: CreateAgentSecurity | undefined;
  options?: RequestOptions;
};

export type CreateAgentMutationData = ManagedAgent;

export type CreateAgentMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * create agents
 */
export function useCreateAgentMutation(
  options?: MutationHookOptions<
    CreateAgentMutationData,
    CreateAgentMutationError,
    CreateAgentMutationVariables
  >,
): UseMutationResult<
  CreateAgentMutationData,
  CreateAgentMutationError,
  CreateAgentMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildCreateAgentMutation(client, options),
    ...options,
  });
}

export function mutationKeyCreateAgent(): MutationKey {
  return ["@gram/client", "agents", "create"];
}

export function buildCreateAgentMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: CreateAgentMutationVariables,
  ) => Promise<CreateAgentMutationData>;
} {
  return {
    mutationKey: mutationKeyCreateAgent(),
    mutationFn: function createAgentMutationFn({
      request,
      security,
      options,
    }): Promise<CreateAgentMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(agentsCreate(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
